import { TOGGLE_CHAT_LIST } from "../constants/actionTypes";

const initialState = {
  chatsListOpened: false,
};

function chatList(state = initialState, action) {
  switch (action.type) {
    case TOGGLE_CHAT_LIST:
      return {
        ...state,
        chatsListOpened: action.status,
      };

    default:
      return state;
  }
}

export default chatList;
